import { render, staticRenderFns } from "./AllResults.vue?vue&type=template&id=2a5042e2&scoped=true&lang=html"
import script from "./AllResults.vue?vue&type=script&lang=js"
export * from "./AllResults.vue?vue&type=script&lang=js"
import style0 from "./AllResults.vue?vue&type=style&index=0&id=2a5042e2&prod&scoped=true&lang=scss"
import style1 from "./AllResults.vue?vue&type=style&index=1&id=2a5042e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5042e2",
  null
  
)

export default component.exports